import { Form, Input, Select, Space } from 'antd'
import React from 'react'

import TableSearch, { TableSearchProps } from '@/components/shared/table-search'
import { normalStatusOptions } from '@/constants/normal-status'
import { SearchRolesQuery } from '@/redux/role'

export default function SearchRole({
  onSearch,
}: Pick<TableSearchProps<SearchRolesQuery>, 'onSearch'>) {
  return (
    <TableSearch<SearchRolesQuery> onSearch={onSearch}>
      <Space>
        <Form.Item label="By role" name="name" >
          <Input placeholder="Role Name" />
        </Form.Item>
        <Form.Item label="By status" name="status" >
          <Select
            options={normalStatusOptions}
            style={{ width: 120 }}
            placeholder="Status"
            allowClear
          ></Select>
        </Form.Item>
      </Space>
    </TableSearch>
  )
}
